import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bdc11c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "code-field" }
const _hoisted_2 = { class: "code-field__inputs" }
const _hoisted_3 = ["disabled", "readonly", "value", "onInput", "onKeydown", "onPaste"]
const _hoisted_4 = { class: "error-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(_ctx.length).keys()], (index) => {
        return (_openBlock(), _createElementBlock("input", {
          key: index,
          ref: "codeInputs",
          class: _normalizeClass(['code-field__input', { haserror: _ctx.hasError }]),
          type: "text",
          placeholder: "",
          maxlength: "1",
          disabled: _ctx.disabled,
          readonly: _ctx.readonly,
          value: _ctx.codeArray[index],
          onInput: ($event: any) => (_ctx.onInput(index, $event)),
          onKeydown: ($event: any) => (_ctx.onKeydown(index, $event)),
          onPaste: ($event: any) => (_ctx.onPaste(index, $event))
        }, null, 42, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.handlesError)
        ? (_openBlock(), _createBlock(_component_Error, {
            key: 0,
            name: _ctx.name,
            "value-field": _ctx.model
          }, null, 8, ["name", "value-field"]))
        : _createCommentVNode("", true)
    ])
  ]))
}